/**
 * La frase de tenis de la pantalla, elegida una vez por visita.
 *
 * SE ELIGE EN EL EFECTO Y NO AL DIBUJAR. Si saliera de `frasAlAzar()` en el
 * cuerpo del componente, cambiaría en cada redibujado —cada vez que llega una
 * respuesta del servidor, cada vez que se abre un desplegable— y la franja
 * de arriba se pondría a parpadear frases mientras la persona lee.
 *
 * DEVUELVE `null` MIENTRAS CARGA Y SI FALLA. La pantalla no dibuja nada en
 * esos dos casos, que es exactamente lo que hacía antes de que existieran
 * las frases: una franja sin frase se ve bien, un «Cargando...» donde iba
 * una frase motivacional no.
 */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { cargarFrases, frasAlAzar } from './index';

export function useFrase(): string | null {
  const { i18n } = useTranslation();
  const idioma = i18n.language;
  const [frase, setFrase] = useState<string | null>(null);

  useEffect(() => {
    let vivo = true;
    void cargarFrases(idioma).then((frases) => {
      // Sin esta guarda, cambiar de idioma dos veces rápido deja puesta la
      // frase del primero: la promesa vieja llega después que la nueva.
      if (vivo) setFrase(frasAlAzar(frases));
    });
    return () => {
      vivo = false;
    };
  }, [idioma]);

  return frase;
}
